import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core'; 
import { MatTableDataSource,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Operacion } from '../../../../models/Operacion';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import { DatePipe,DecimalPipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { OperacionService } from '../../../../services/operaciones/operacion/operacion.service';
import { SolicitudDesembolsoService } from '../../../../services/operaciones/solicitud-desembolso/solicitud-des.service';
import { Proforma } from 'app/models/Proforma';
import { LoginService } from 'app/services/login/login.service';

export const MY_FORMATS = {
    parse: {
        dateInput: "DD-MM-YYYY"
    },
    display: {
        dateInput: "DD-MM-YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY"
    }
};

declare var $: any;
@Component({
  selector: 'app-generar-solicitud-des',
  templateUrl: './generar-solicitud-des.component.html',
  styleUrls: ['./generar-solicitud-des.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates, Operacion, Proforma,
    DatePipe,DecimalPipe,
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
]
})
export class GenerarSolicitudDesComponent implements OnInit {
  idEmpresa: number = 0;

  operacion: any = [];
  operacionDet: any = [];
  user: any;
  Simboloi: string;
  dataSolicitudD: any = [];
  ContratoTotales: any = [];
  cont: number = 0;
  dataSolDes:any=[];

  loading: boolean = false;
  @Input() SolicitudDesGeneral: any = [];
  @Output() cerrarGenerarSoliDes: EventEmitter<boolean>;

  formularioGenerarSoliDes: FormGroup;
  formularioCrearSoliDes: FormGroup;


  dataSource: any;
  dataSourceConDetalle: any;

  constructor(private operacionService: OperacionService,
      private routerActive: ActivatedRoute,
      private decimalPipe: DecimalPipe,
      private router: Router,
      private solicitudDesembolsoService: SolicitudDesembolsoService,
      private msgTitulos: MessagesTitles,
      private loginService: LoginService) {

      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.routerActive.params.subscribe(params => {

          this.cerrarGenerarSoliDes = new EventEmitter();

          this.idEmpresa = params['id'];
      })
      this.formularioGenerarSoliDes = new FormGroup({
          "idOperacion": new FormControl('', Validators.required),
          "idUser": new FormControl(''),
          "Proveedor": new FormControl('', Validators.required),
          "Adquirente": new FormControl('', Validators.required),
          "MonedaDescripcion": new FormControl('', Validators.required),
          "Fecha_Contrato": new FormControl('', Validators.required),
          "Adelanto": new FormControl('', Validators.required),
          "TEM": new FormControl('', Validators.required),
          "Desembolso": new FormControl('', Validators.required)
      });

      this.formularioCrearSoliDes = new FormGroup({
          idOperacion: new FormControl(''),
          Adelanto_A_Ejecutar: new FormControl(''),
          Usuario: new FormControl('')
      }); 
  }

  ngOnInit() {
      
      this.dataSource = new MatTableDataSource(this.SolicitudDesGeneral); 
      
  } 
  ngAfterViewInit(){
        for (let arraySol of this.SolicitudDesGeneral) {
            if(arraySol.Tipo_Servicio == 1379 || arraySol.Tipo_Servicio == 1485 ){  
                this.fullMount(arraySol.idOperacion); 
            }
        }
  }
 
  
  cortarComa(numero: any): number {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }
  CerrarPopUp() {
      this.cerrarGenerarSoliDes.emit();
  }

  guardarSoliDes() {
      let body: any = { 'SolicitudDesembolso': [] };
      let adelanto: number = 0;
      let minimo: number = 0;
      let cantidad: number = 0;
      let advertencia: number = 0;
      let mensaje = "";
      

      for (let array of this.SolicitudDesGeneral) {
          cantidad += 1; 
          
        let montoDesembolsar: number = 0;
          montoDesembolsar = (this.cortarComa($("#" + array.idOperacion).val()));
          minimo = parseFloat(array.Adelanto_importe) * 0.2;
          adelanto = parseFloat(array.Adelanto_Ejecutado_importe) + montoDesembolsar;

          if (adelanto > minimo) {
              this.formularioCrearSoliDes.controls['idOperacion'].setValue(array.idOperacion);
              this.formularioCrearSoliDes.controls['Adelanto_A_Ejecutar'].setValue(montoDesembolsar);
              this.formularioCrearSoliDes.controls['Usuario'].setValue(this.user.Usuario);
              body.SolicitudDesembolso.push(this.formularioCrearSoliDes.getRawValue());
          } else {
              this.showNotification('warning', 'top', 'right', 'El monto a desembolsar para el Contrato N° ' + array.idOperacion + ' debe ser mayor al 50% .');
              advertencia += 1;
          }
      }
      if (body.SolicitudDesembolso.length <= 0) {
          Swal.fire(
              'Relación de operacion vacía',
              'Revisar si los documentos seleccionados cumplen con las reglas del proceso',
              'warning'
          )
          return;
      }

      mensaje = (advertencia > 0 ? "Tiene advertencia sobre alguna(s) operación(es)" : "Relación de operación lista para generar su(s) solicitud(es) de desembolso");
      Swal.fire({
          title: '¿Desea continuar?',
          text: mensaje,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, continuar',
          cancelButtonText: 'No, cancelar',
          heightAuto: false
      }).then((result) => {
          if (result.value) {
              Swal.fire({
                  title: "Espere...",
                  text: "Guardando información",
                  type: "info",
                  allowOutsideClick: false,
                  heightAuto: false
              });
              
              Swal.showLoading();
              this.solicitudDesembolsoService.crearSoliDes(body).subscribe(
                  res => {
                      this.dataSolicitudD = res;
                      this.NotificarSoliDes(this.dataSolicitudD);
                      this.loading = false;
                      Swal.fire({
                          title: "Realizado",
                          text: "Información registrada correctamente",
                          type: "success",
                          allowOutsideClick: false,
                          heightAuto: false
                      }).then(resp => {
                          if (resp.value == true) {
                              this.loginService.clickGuard = true;
                              this.router.navigate(["/operaciones/solicitudDesembolso/listado"]);
                          }
                      });
                  }, err => {
                    err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
                
                      Swal.fire({
                          title: this.msgTitulos.Error_Algo_Salio_Mal,
                          text: err.error.error,
                          type: "warning",
                          allowOutsideClick: false,
                          heightAuto: false
                      });
                      this.loading = false;
                  }
              );
          }
      });
  }

  NotificarSoliDes($soliDes) {
      for (let array of $soliDes) {
          if (array.Save) {
              this.showNotification('success', 'top', 'right', 'La Solicitud de desembolso de la operación N° ' + array.idOperacion + ' ha sido generado.');
          } else {
              this.showNotification('danger', 'top', 'right', 'La Solicitud de desembolso para la operación N° ' + array.idOperacion + ' no ha sido generado.');
          }
      }
  }

  actualizarContrato(idOperacion) {

      let body: any = { "idOperacion": idOperacion, "Estado": "D" }

      this.operacionService.actualizarEstado(body, idOperacion).subscribe(
          res => {
              this.showNotification('success', 'top', 'right', 'Operacion N° ' + idOperacion + ' actualizado.');
          }, err => {
              if (err.error.code == 500) {
                  err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
              }
              let error = "";
              error = err.error.error;
              this.showNotification('warning', 'top', 'right', 'No se pudo actualizar el operacion N° ' + idOperacion + '. \n Error: ' + error);
          });
  }

  validarInput() {
      for (let array of this.SolicitudDesGeneral) {
          if (parseFloat($("#" + array.idOperacion).val()) > parseFloat(array.Adelanto_Pendiente_importe)) {
              $("#" + array.idOperacion).val(array.Adelanto_Pendiente_importe);
          } else if (parseFloat($("#" + array.idOperacion).val()) < 0) {
              $("#" + array.idOperacion).val(0);
          }
      }
  }

  fullMount(idOperacion) { 
      for (let array of this.SolicitudDesGeneral) {
          if (array.idOperacion == idOperacion) {
              if ($("#" + array.idOperacion).val() == array.Adelanto_Pendiente_importe) { 
                $("#" + array.idOperacion).val(0);
              } else {   
                  $("#" + array.idOperacion).val(array.Adelanto_Pendiente_importe);
                  let valor;
                    valor = this.decimalPipe.transform(
                        this.cortarComa( $("#" + array.idOperacion).val()),
                        `1.2-2`
                    );
                    $("#" + array.idOperacion).val(valor);
              }
          }
      }

  }

  showNotification(type, from, align, message) {

      //const type = ['','info','success','warning','danger']; => tipo de notificacion
      //from = [Top,bottom,etc] => orientacion vertical
      //align = center, left, right => orientacion horizontal

      $.notify({
          icon: "notifications",
          message: message
      }, {
          type: type,
          timer: 4000,
          placement: {
              from: from,
              align: align
          },
          template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
              '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
              '<i class="material-icons" data-notify="icon">notifications</i> ' +
              '<span data-notify="title">{1}</span> ' +
              '<span data-notify="message">{2}</span>' +
              '<div class="progress" data-notify="progressbar">' +
              '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
              '</div>' +
              '<a href="{3}" target="{4}" data-notify="url"></a>' +
              '</div>'
      });
  }



}

